"use client";
import React from "react";
import "./components.css";
import { Col, Container, Row } from "react-bootstrap";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import dotGrid from "../../public/assets/images/dot-grid.png";
import Image from "next/image";

const stats = [
  { value: 7, suffix: "+", label: "Year of Experience" },
  { value: 20, suffix: "x", label: "Growth Rate" },
  { value: 50, suffix: "+", label: "Expert Professionals" },
  { value: 120, suffix: "+", label: "Projects Delivered" },
];

const ExperiencesCard = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <div className="experiences-card" ref={ref}>
      <Container className="experiences-card-main">
        <div className="bg-overlay" />
        <Image
          src={dotGrid}
          width={150}
          height={"auto"}
          className="img-fluid move-img"
          style={{ top: "-50px" }}
          alt="animation"
        />
        <Row>
          <Col xl={12} className="text-center">
            <h4 className="experiences-text">
              We develop strategic software solutions for businesses.
            </h4>
          </Col>

          {stats.map((stat, index) => (
            <Col key={index} xl={3} sm={6} className="text-center count-box reveal fade-bottom">
              <h2>
                {inView ? <CountUp end={stat.value} duration={3} /> : 0}
                {stat.suffix}
              </h2>
              <p className="p-0 m-0">{stat.label}</p>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default ExperiencesCard;
